/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUserConfigurationRequest } from '../../models/update-user-configuration-request';
import { UserConfigurationDto } from '../../models/user-configuration-dto';

export interface UpdateUserConfiguration$Params {
      body: UpdateUserConfigurationRequest
}

export function updateUserConfiguration(http: HttpClient, rootUrl: string, params: UpdateUserConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<UserConfigurationDto>> {
  const rb = new RequestBuilder(rootUrl, updateUserConfiguration.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserConfigurationDto>;
    })
  );
}

updateUserConfiguration.PATH = '/v0/userConfigurations';
